/* eslint-env browser */

const body = document.querySelector('body')
const home = body.querySelector('.home')
const menu = body.querySelector('.menu')
const content = body.querySelector('.content')
const login = home.querySelector('.login-btn')
const single = document.querySelector('.single')

const setPadding = (padding, isSinglePage, ...args) => {
  if (isSinglePage) body.style.paddingRight = padding
  else {
    login.style.right = padding
    args.forEach(item => {
      item.style.paddingRight = padding
    })
  }
}
const noScroll = () => { // eslint-disable-line no-unused-vars
  let padding

  if (!body.classList.contains('--no-scroll')) padding = `${scrollbarWidth}px` // eslint-disable-line no-undef
  else padding = 0

  fastdom.mutate(() => {
    body.classList.toggle('--no-scroll')
    setPadding(padding, single, home, menu, content)
  })
}
